var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRsvp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.333 136.667H26.6667C19.3333 136.667 13.3333 130.667 13.3333 123.333V53.6667C13.3333 49.3333 15.3333 45.3333 19 42.6667L80 0L141 42.6667C144.667 45 146.667 49.3333 146.667 53.6667V123.333C146.667 130.667 140.667 136.667 133.333 136.667Z",
    fill: "#3B5F59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 68H120V134H40V68Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6667 106.25H91.5417L88.1875 117.75H85.3125L81.9583 106.25H84.8333L86.75 112.824L88.6667 106.25ZM67.775 113.725L69.5 117.75H66.625L64.9958 113.917H62.7917V117.75H59.9167V106.25H66.625C68.2542 106.25 69.5 107.496 69.5 109.125V111.042C69.5 112.192 68.7333 113.246 67.775 113.725ZM66.625 109.125H62.7917V111.042H66.625V109.125ZM99.2083 113.917H95.375V117.75H92.5V106.25H99.2083C100.799 106.25 102.083 107.534 102.083 109.125V111.042C102.083 112.632 100.799 113.917 99.2083 113.917ZM99.2083 109.125H95.375V111.042H99.2083V109.125ZM80.0417 106.25V109.125H74.2917V110.562H78.125C79.1792 110.562 80.0417 111.425 80.0417 112.479V115.833C80.0417 116.887 79.1792 117.75 78.125 117.75H71.4167V114.875H77.1667V113.438H72.8542C72.0683 113.438 71.4167 112.786 71.4167 112V108.167C71.4167 107.112 72.2792 106.25 73.3333 106.25H80.0417Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M133.333 136.667H26.6667C19.3333 136.667 13.3333 130.667 13.3333 123.333V56.6665L80 99.9998L146.667 56.6665V123.333C146.667 130.667 140.667 136.667 133.333 136.667Z",
    fill: "#629E94"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRsvp);
export default __webpack_public_path__ + "static/media/rsvp.f919aae9e53253735175bdd22f1f8ee8.svg";
export { ForwardRef as ReactComponent };